document.addEventListener('DOMContentLoaded', function () {
	if (typeof Swiper === 'undefined') return;

	document.querySelectorAll('[data-block-id]').forEach((block) => {
		// only handle step-carousel blocks
		if (!block.classList.contains('step-carousel-group')) return;

		const carousel = block.querySelector('.step-carousel-group__carousel');
		if (!carousel) return;

		const paginationEl = block.querySelector('.swiper-pagination');

		new Swiper(carousel, {
			slidesPerView: 1.3,
			spaceBetween: 50,
			centeredSlides: false,
			slidesOffsetBefore: 20,
			slidesOffsetAfter: 20,
			pagination: {
				el: paginationEl || '.swiper-pagination',
				clickable: true,
			},
			breakpoints: {
				380: { slidesPerView: 1.5 },
				540: { slidesPerView: 1.8 },
				750: { slidesPerView: 2.5, slidesOffsetBefore: 60, slidesOffsetAfter: 60 },
				1024: { slidesPerView: 3.5, slidesOffsetBefore: 60, slidesOffsetAfter: 60 },
				1280: { slidesOffsetBefore: 0, slidesOffsetAfter: 0, slidesPerView: 4 },
			},
		});
	});
});

